module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Cap-1-f72cb6e0e715b575113d2eeafaf1bf13.svg";